import { styled } from "twin.macro";

import cancelProcessSrc from "../../../assets/images/integrations/cancel-process.svg";
import { ExtraFeature } from "../../common/IntegrationDetail";
import SvgObject from "../../elements/SvgObject";

const ZoomSvg = styled(SvgObject)`
  width: 100%;
  transform: scale(1.13);
`;

const offloadCancellation = (title: string): ExtraFeature => ({
  headline: "Offload your cancellation process",
  description: `ProsperStack manages your entire cancellation process. We use your ${title} account to handle cancellations, prevent churn with discounts and incentives, collect feedback and track recovered revenue — automatically.`,
  image: <ZoomSvg data={cancelProcessSrc} width={596} height={302} />,
});

export default offloadCancellation;
